import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sinceDate'
})
export class SinceDatePipe implements PipeTransform {

  transform(value: Date, refreshParam): unknown {
    // @ts-ignore
    const seconds = Math.floor((new Date() - value) / 1000);

    let interval = seconds / 31536000;

    if (interval > 1) {
      return Math.floor(interval) + " years ago";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
      return Math.floor(interval) + " months ago";
    }
    interval = seconds / 86400;
    if (interval > 1) {
      return Math.floor(interval) + " days ago";
    }
    interval = seconds / 3600;
    if (interval > 1) {
      return Math.floor(interval) + " hours ago";
    }
    interval = seconds / 60;
    if (interval > 1) {
      return Math.floor(interval) + " min ago";
    }
    if (interval === 1) {
      return Math.floor(interval) + " min ago";
    }
    return 'Just now';
    // return Math.floor(seconds) + " seconds";
  }
}
